import CustomerStorySmallCard from "@components/BasicComponents/Cards/CustomerStory/CustomerStorySmallCard"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import {useLocale} from "@components/Contexts/LocaleContext"
import Asset from "@components/CustomTypography/Asset/Asset"
import Description from "@components/CustomTypography/Description/Description"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Paragraph from "@components/CustomTypography/Paragraph/Paragraph"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import ButtonComponent from "@components/Theme/Button/Button"
import {getPosts} from "@config/modules"
import {getLink} from "@hooks/PagesData/getLink"
import {checkIfCustomerStoryIn} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyAdditionalFunctions"
import {
	CategoryModuleType,
	CustomerStoryModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import CustomerPosts from "@jsons/customerStories.json"
import React from "react"

import styles from "./CustomerStoryPost.module.scss"

type Props = {
	article: string
	data: CustomerStoryModuleType
}

const CustomerStoryPost = (props: Props) => {
	const Stories = getPosts("CustomerStoriesModule", {data: CustomerPosts})

	const data = props.data
	const {changeLocale: changeLocaleCustome} = useLocale()
	changeLocaleCustome(props.data.lang)
	const categories = data.useCase.map(
		(element: CategoryModuleType, index: number) => {
			return element.slug
		},
	)

	let storiesData = Stories

	if (typeof storiesData !== "undefined") {
		storiesData = Stories.filter(
			(element: any) => element.slug !== data.slug,
		)
		const FilteredBlogData = checkIfCustomerStoryIn(storiesData, categories)

		if (FilteredBlogData.length > 0) {
			storiesData = FilteredBlogData

			if (FilteredBlogData.length === 1) {
				storiesData.push(
					Stories.filter(
						(element: any) =>
							element.slug !== data.slug &&
							element.slug !== storiesData[0].slug,
					)[0],
				)
			}
		}
	}

	const preview = data.inside.src ? data.inside : data.preview

	return (
		<>
			<ContainerWrapper style={{overflow: "hidden"}}>
				<Separator
					className={styles.post__container}
					type={"padding"}
					withoutMeasure
				>
					<Separator>
						<NewResponsiveImage
							imageClassName={styles.logo}
							withoutContainer
							{...props.data.logo}
						/>

						<Separator size={16} />
						<Title
							className={styles.title}
							content={data.title}
							fontWeight={600}
							size={"M"}
							type={"1"}
						/>
						<Paragraph
							content={
								<>
									{data.useCase.map(
										(
											element: CategoryModuleType,
											index: number,
										) => {
											return (
												<React.Fragment key={index}>
													<ButtonComponent
														buttonType={"unstyled"}
														className={
															styles.categories
														}
														link={
															getLink(
																"customerStories",
															) +
															"?useCases=" +
															props.data
																.useCase[0]
																.slug +
															getLink(
																"startOfPaginatoinM",
															)
														}
														asLink
													>
														{element.title}
													</ButtonComponent>
												</React.Fragment>
											)
										},
									)}
									{data.industry.map(
										(
											element: CategoryModuleType,
											index: number,
										) => {
											return (
												<React.Fragment key={index}>
													|
													<ButtonComponent
														buttonType={"unstyled"}
														className={
															styles.categories
														}
														link={
															getLink(
																"customerStories",
															) +
															"?industries=" +
															props.data
																.industry[0]
																.slug +
															getLink(
																"startOfPaginatoinM",
															)
														}
														asLink
													>
														{element.title}
													</ButtonComponent>
												</React.Fragment>
											)
										},
									)}
								</>
							}
							fontWeight={400}
							size={"XS"}
						/>
					</Separator>

					{preview?.type === "video" && (
						<Separator
							className={styles.asset__container}
							size={16}
							type={"padding"}
							withoutMeasure
						>
							<Asset
								data={{
									...preview,
								}}
								type={preview.type}
							/>
						</Separator>
					)}

					<Separator
						className={styles.contentContainer}
						size={16}
						type={"padding"}
					>
						<Description
							content={data.content}
							fontWeight={400}
							size={"L"}
						/>
					</Separator>
					<Separator />
				</Separator>
			</ContainerWrapper>

			<Separator className={styles.cardsBox} size={128}>
				<ContainerWrapper>
					<Title
						content={"More Customer Stories"}
						fontWeight={600}
						size={"XL"}
						type={"1"}
						center
					/>
					<Separator />
					{storiesData.length > 0 && (
						<Separator
							className={styles.cardContainer}
							type={"padding"}
							withoutMeasure
						>
							{storiesData.map((element: any, index: number) => {
								if (index < 2) {
									return (
										<CustomerStorySmallCard
											key={index}
											className={styles.cardBox}
											data={element}
										/>
									)
								}
								return undefined
							})}
						</Separator>
					)}
				</ContainerWrapper>
			</Separator>
		</>
	)
}

export default CustomerStoryPost
